module.exports = __webpack_public_path__ + "static/img/shangke.f48605d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shangke.png
// module id = 2hh3
// module chunks = 1